import styled from 'styled-components'

type TColor = {
  color: string
}

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  li:not(:first-child) {
    border-top: 1px solid var(--gray200);
  }
`

export const Item = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  column-gap: 16px;
  border-radius: 8px;
  border: 1px solid var(--gray200);
  background: var(--white-100);
  margin-bottom: 24px;

  span {
    width: 100%;
  }
`

export const IconLabel = styled.div``

export const GreenCircle = styled.div<TColor>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: ${({ color }) => (color === 'error' ? 'var(--error500' : 'var(--success500')});
  border-radius: 50%;
`
